import React, { createContext, useState, useContext } from 'react';
import { CountryCode, DEFAULT_COUNTRY_CODE } from '../utils/countries';

type CountryContextType = {
    country: CountryCode;
    setCountry: (country: CountryCode) => void;
};

const CountryContext = createContext<CountryContextType | undefined>(undefined);

export const CountryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [country, setCountry] = useState<CountryCode>(DEFAULT_COUNTRY_CODE);

    return (
        <CountryContext.Provider value={{ country, setCountry }}>
            {children}
        </CountryContext.Provider>
    );
};

export const useCountry = () => {
    const context = useContext(CountryContext);
    if (!context) {
        throw new Error('useCountry must be used within a CountryProvider');
    }
    return context;
};
